import { render, staticRenderFns } from "./Detail_employee.vue?vue&type=template&id=44cc9c9a&scoped=true&"
import script from "./Detail_employee.vue?vue&type=script&lang=js&"
export * from "./Detail_employee.vue?vue&type=script&lang=js&"
import style0 from "./Detail_employee.vue?vue&type=style&index=0&id=44cc9c9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cc9c9a",
  null
  
)

export default component.exports